/**
 * Created by handd on 2021/10/31.
 * 消息组管理
 */
import axios from "axios";
import {message} from "antd";

// const
const MESSAGE_GROUP_TOGGLE_LOADING = "messageGroup/MESSAGE_GROUP_TOGGLE_LOADING";//加载标志
const MESSAGE_GROUP_TOGGLE_BUTTON_LOADING = "messageGroup/MESSAGE_GROUP_TOGGLE_BUTTON_LOADING";//提交加载标志
const MESSAGE_GROUP_UPDATE_DATA = "messageGroup/MESSAGE_GROUP_UPDATE_DATA";
const MESSAGE_GROUP_STORE_MESSAGE_GROUPS = "messageGroup/MESSAGE_GROUP_STORE_MESSAGE_GROUPS";
const MESSAGE_GROUP_STORE_RELOAD_MESSAGE_GROUPS = "messageGroup/MESSAGE_GROUP_STORE_RELOAD_MESSAGE_GROUPS";
const MESSAGE_GROUP_ADD_MESSAGE_GROUP = "messageGroup/MESSAGE_GROUP_ADD_MESSAGE_GROUP";
const MESSAGE_GROUP_EDIT_MESSAGE_GROUP = "messageGroup/MESSAGE_GROUP_EDIT_MESSAGE_GROUP";
const MESSAGE_GROUP_VIEW_MESSAGE_GROUP = "messageGroup/MESSAGE_GROUP_VIEW_MESSAGE_GROUP";
const MESSAGE_GROUP_ADD_MESSAGE_MEMBER = "messageGroup/MESSAGE_GROUP_ADD_MESSAGE_MEMBER";
const MESSAGE_GROUP_MINUS_MESSAGE_MEMBER = "messageGroup/MESSAGE_GROUP_MINUS_MESSAGE_MEMBER";
const MESSAGE_GROUP_STORE_DEPARTMENTS = "messageGroup/MESSAGE_GROUP_STORE_DEPARTMENTS";
const MESSAGE_GROUP_STORE_POSITIONS = "messageGroup/MESSAGE_GROUP_STORE_POSITIONS";
const MESSAGE_GROUP_STORE_WORK_GROUPS = "messageGroup/MESSAGE_GROUP_STORE_WORK_GROUPS";
const MESSAGE_GROUP_STORE_WORK_USERS = "messageGroup/MESSAGE_GROUP_STORE_WORK_USERS";
const MESSAGE_GROUP_STORE_ROLES = "messageGroup/MESSAGE_GROUP_STORE_ROLES";
const MESSAGE_GROUP_ADD_MESSAGE_MEMBER_BY_ROLE = "messageGroup/MESSAGE_GROUP_ADD_MESSAGE_MEMBER_BY_ROLE";

// reducer
export const messageGroup = (state = {
  loading: false,
  buttonLoading: false,
  addVisible: false,
  editVisible: false,
  viewVisible: false,
  addUserVisible: false,
  minusUserVisible: false,

  messageGroups: [],
  messageGroup: {},
  departments: [],
  positions: [],
  workGroups: [],
  workUsers: [],
  roles: [],

  selectedMembers: [],
  selectedRowKeys: []

}, action) => {
  switch (action.type) {
    case MESSAGE_GROUP_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case MESSAGE_GROUP_TOGGLE_BUTTON_LOADING:
      return {
        ...state,
        buttonLoading: action.data
      };
    case MESSAGE_GROUP_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MESSAGE_GROUP_STORE_MESSAGE_GROUPS:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addVisible: false,
        editVisible: false,
        viewVisible: false,
        addUserVisible: false,
        messageGroups: action.data,
        messageGroup: {},
        positions: [],
        workGroups: [],
        workUsers: [],
        selectedMembers: [],
        selectedRowKeys: [],
      };
    case MESSAGE_GROUP_STORE_RELOAD_MESSAGE_GROUPS: {
      let index = action.data.findIndex(d => d.id === state.messageGroup.id);
      let messageGroup = index > -1 ? action.data[index] : {};
      console.info(messageGroup);
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addVisible: false,
        editVisible: false,
        viewVisible: false,
        // addUserVisible: false,
        messageGroups: action.data,
        messageGroup: messageGroup,
        // positions: [],
        // workGroups: [],
        // workUsers: [],
        selectedMembers: [],
        selectedRowKeys: [],
      };
    }
    case MESSAGE_GROUP_ADD_MESSAGE_GROUP:
      return {
        ...state,
        messageGroup: {},
        addVisible: true
      };
    case MESSAGE_GROUP_EDIT_MESSAGE_GROUP:
      return {
        ...state,
        messageGroup: action.data,
        editVisible: true
      };
    case MESSAGE_GROUP_VIEW_MESSAGE_GROUP:
      return {
        ...state,
        messageGroup: action.data,
        viewVisible: true
      };
    case MESSAGE_GROUP_ADD_MESSAGE_MEMBER:
      return {
        ...state,
        messageGroup: action.data,
        positions: [],
        workGroups: [],
        workUsers: [],
        selectedMembers: [],
        selectedRowKeys: [],
        addUserVisible: true
      };
    case MESSAGE_GROUP_MINUS_MESSAGE_MEMBER:
      return {
        ...state,
        messageGroup: action.data,
        selectedRowKeys: [],
        minusUserVisible: true
      };
    case MESSAGE_GROUP_STORE_DEPARTMENTS:
      return {
        ...state,
        departments: action.data,
        positions: [],
        workGroups: [],
      };
    case MESSAGE_GROUP_STORE_POSITIONS:
      return {
        ...state,
        positions: action.data,
      };
    case MESSAGE_GROUP_STORE_WORK_GROUPS:
      return {
        ...state,
        workGroups: action.data,
      };
    case MESSAGE_GROUP_STORE_WORK_USERS:
      return {
        ...state,
        workUsers: action.data,
        selectedMembers: [],
        selectedRowKeys: [],
      };
    case MESSAGE_GROUP_STORE_ROLES:
      return {
        ...state,
        roles: action.data,
      }
    case MESSAGE_GROUP_ADD_MESSAGE_MEMBER_BY_ROLE:
      return {
        ...state,
        messageGroup: action.data,
        workUsers: [],
        selectedMembers: [],
        selectedRowKeys: [],
        addUserByRoleVisible: true
      }
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateMessageGroupData = (data) => {
  return {
    type: MESSAGE_GROUP_UPDATE_DATA,
    data: data
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: MESSAGE_GROUP_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle button loading
 */
export const toggleButtonLoading = (show) => {
  return {
    type: MESSAGE_GROUP_TOGGLE_BUTTON_LOADING,
    data: show
  }
};

/**
 * query all message groups
 */
export const queryMessageGroups = (data) => (dispatch) => {
  axios.get(`/api-message/messageGroups`, {contentGroup: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageGroups(response.data));
          // message.success("查询成功", 1);
        } else {
          message.warning("未获取到消息组", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息组错误：" + err.data, 3);
  });
};

/**
 * store all message groups
 */
export const storeMessageGroups = (messageGroups) => {
  return {
    type: MESSAGE_GROUP_STORE_MESSAGE_GROUPS,
    data: messageGroups
  }
};

/**
 * reload message groups
 */
export const reloadMessageGroups = (data) => (dispatch) => {
  axios.get(`/api-message/messageGroups`, {contentGroup: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeReloadMessageGroups(response.data));
          message.success("刷新成功", 1);
        } else {
          message.warning("未查询到消息组", 3);
        }
      }
    }
  ).catch(err => {
    message.error("刷新错误：" + err.data, 3);
  });
};


/**
 * store reload message groups
 */
export const storeReloadMessageGroups = (messageGroups) => {
  return {
    type: MESSAGE_GROUP_STORE_RELOAD_MESSAGE_GROUPS,
    data: messageGroups
  }
};

/**
 * add message group
 */
export const addMessageGroup = () => {
  return {
    type: MESSAGE_GROUP_ADD_MESSAGE_GROUP,
  }
};

/**
 * edit message group
 */
export const editMessageGroup = (messageGroup) => {
  return {
    type: MESSAGE_GROUP_EDIT_MESSAGE_GROUP,
    data: messageGroup
  }
};

/**
 * view message group
 */
export const viewMessageGroup = (messageGroup) => {
  return {
    type: MESSAGE_GROUP_VIEW_MESSAGE_GROUP,
    data: messageGroup
  }
};

/**
 * submit message group
 */
export const submitMessageGroup = (data) => (dispatch) => {
  message.loading({content: `保存中……`, key: "submit"});
  axios({
    method: "POST",
    url: `/api-message/messageGroup`,
    contentGroup: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: `保存成功`, key: "submit", duration: 1});
        data.reload();
      } else {
        message.error({content: `保存失败！`, key: "submit", duration: 3});
        dispatch(toggleButtonLoading(false));
      }
    }
  ).catch(err => {
    message.error({content: "保存错误：" + err.data, key: "submit", duration: 3});
    dispatch(toggleButtonLoading(false));
  });
};

/**
 * delete message group
 */
export const deleteMessageGroup = (data) => (dispatch) => {
  message.loading({content: "删除中……", key: "delete"});
  axios({
    method: "DELETE",
    url: `/api-message/messageGroup`,
    contentGroup: "application/json",
    withCredentials: true,
    data: data.ids,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: "删除成功", key: "delete", duration: 1});
        data.reload();
      } else {
        message.error({content: "删除失败", key: "delete", duration: 3});
      }
    }
  ).catch(err => {
    message.error({content: "删除错误：" + err.data, key: "delete", duration: 3});
  });
};

/**
 * add message member
 */
export const addMessageMember = (messageGroup) => {
  return {
    type: MESSAGE_GROUP_ADD_MESSAGE_MEMBER,
    data: messageGroup,
  }
};
/**
 * minus message member
 */
export const minusMessageMember = (messageGroup) => {
  return {
    type: MESSAGE_GROUP_MINUS_MESSAGE_MEMBER,
    data: messageGroup,
  }
};

/**
 * get departments by enterprise
 */
export const getDepartments = (enterprise) => (dispatch) => {
  axios.get(`/api-user/getDepartments?enterpriseId=${enterprise}`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeDepartments(response.data));
        } else {
          message.warning("未获取到部门", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取部门错误：" + err.data, 3);
  });
};

/**
 * store departments
 */
export const storeDepartments = (departments) => {
  return {
    type: MESSAGE_GROUP_STORE_DEPARTMENTS,
    data: departments
  }
};

/**
 * get positions by department
 */
export const getPositions = (department) => (dispatch) => {
  axios.get(`/api-user/getPositions?departmentId=${department}`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storePositions(response.data));
        } else {
          message.warning("未获取到岗位", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取岗位错误：" + err.data, 3);
  });
};

/**
 * store positions
 */
export const storePositions = (positions) => {
  return {
    type: MESSAGE_GROUP_STORE_POSITIONS,
    data: positions
  }
};

/**
 * get work groups by department
 */
export const getWorkGroups = (department) => (dispatch) => {
  axios.get(`/api-user/getWorkGroups?departmentId=${department}`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeWorkGroups(response.data));
        } else {
          message.warning("未获取到班组", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取班组错误：" + err.data, 3);
  });
};

/**
 * store work groups
 */
export const storeWorkGroups = (workGroups) => {
  return {
    type: MESSAGE_GROUP_STORE_WORK_GROUPS,
    data: workGroups
  }
};

/**
 * query work users
 */
export const queryWorkUsers = (data) => (dispatch) => {
  axios.get(`/api-user/usersWithWorkInfo?enterprise=${data.enterprise}&department=${data.department}&position=${data.position}&user=${data.user}`,
    {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeWorkUsers(response.data));
        } else {
          message.warning("未获取到用户", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取用户错误：" + err.data, 3);
  });
};

/**
 * store all work users
 */
export const storeWorkUsers = (workUsers) => {
  return {
    type: MESSAGE_GROUP_STORE_WORK_USERS,
    data: workUsers
  }
};

/**
 * submit message member
 */
export const submitMessageMember = (data) => (dispatch) => {
  message.loading({content: `提交中……`, key: "submit"});
  axios({
    method: "POST",
    url: `/api-message/messageMembers`,
    contentGroup: "application/json",
    withCredentials: true,
    data: data.messageMembers,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: `提交成功`, key: "submit", duration: 1});
        data.reload();
      } else {
        message.error({content: `提交失败！`, key: "submit", duration: 3});
        dispatch(toggleButtonLoading(false));
      }
    }
  ).catch(err => {
    message.error({content: "保存错误：" + err.data, key: "submit", duration: 3});
    dispatch(toggleButtonLoading(false));
  });
};

/**
 * delete message member
 */
export const deleteMessageMember = (data) => (dispatch) => {
  message.loading({content: "删除中……", key: "delete"});
  axios({
    method: "DELETE",
    url: `/api-message/messageMember`,
    contentGroup: "application/json",
    withCredentials: true,
    data: data.ids,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: "删除成功", key: "delete", duration: 1});
        data.reload();
      } else {
        message.error({content: "删除失败", key: "delete", duration: 3});
      }
    }
  ).catch(err => {
    message.error({content: "删除错误：" + err.data, key: "delete", duration: 3});
  });
};


export const getRoles = (enterprise) => (dispatch) => {
  let enterprise = !enterprise ? "00000000-0000-0000-0000-000000000000" : enterprise
  axios.get(`/api-user/roles?enterpriseId=${enterprise}`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeRoles(response.data));
        } else {
          message.warning("未获取到权限", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取权限错误：" + err.data, 3);
  });
};

/**
 * store roles
 */
export const storeRoles = (roles) => {
  return {
    type: MESSAGE_GROUP_STORE_ROLES,
    data: roles
  }
};

export const addMessageMemberByRole = (messageGroup) => {
  return {
    type: MESSAGE_GROUP_ADD_MESSAGE_MEMBER_BY_ROLE,
    data: messageGroup,
  }
};

export const queryWorkUsersByRole = (data) => (dispatch) => {
  axios.get(`/api-user/roleWithUsers?role=${data.role}&user=${data.user}`,
    {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeWorkUsers(response.data));
        } else {
          message.warning("未获取到用户", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取用户错误：" + err.data, 3);
  });
};
